module.exports = __webpack_public_path__ + "static/img/applyManagementIcon.e48d3015.png";